export const timeAndMaterialSection = {
     panelTitle:"Cost Worksheet",
     panelDescription:"T&M worksheet",
     tableHead:"TIME AND MATERIAL SECTION",
     editType:"edit",
     close:"Close",
     keyValues:{
        totalTM:'totalTM',
        totalCost:'totalCost'
     },
     tableColumnNames:{
         hourRate:"HOURLY rate",
         labourHour:"# of Labor Hours",
         labourCost:"Total Labor Cost",
         addSimbol:"(+)",
         materialCost:"Material Cost",
         totalTmCost:"TOTAL T& M Cost"
     },
    placeHolderValues:{
        hourlyRate:"0.00",
        labourHour:"0",
        materialCost:"0.00"
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/e-commerce/time-material.ts